import React, { useEffect, useState } from "react";
import styled, { keyframes } from "styled-components";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";

interface IChartProps {
  size: string;
  color: string;
  percent: number;
}

const DounutChart = (props: IChartProps) => {
  const [percentage, setPercentage] = useState(0);

  useEffect(() => {
    setTimeout(() => {
      setPercentage(props.percent);
    }, 1000);
  }, [props.percent]);
  // const percentage = 90;
  return (
    <Chart size={props.size}>
      {/*https://www.npmjs.com/package/react-circular-progressbar*/}
      <CircularProgressbar
        value={percentage}
        strokeWidth={25}
        styles={buildStyles({
          strokeLinecap: "butt",
          pathTransitionDuration: 1,
          pathColor: props.color,
          trailColor: "#e7e9ef",
        })}
      />
    </Chart>
  );
};

const Chart = styled.div<{ size: string }>`
  width: ${(props) => props.size};
  height: ${(props) => props.size};
  position: relative;
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
`;

const AniSvg = styled.svg`
  position: relative;
  width: 100%;
  height: 100%;
`;

const circleFill = keyframes`
    0%{
        stroke-dasharray:0 ${2 * Math.PI * 90};
    }
`;

const AnimatedCircle = styled.circle`
  transform: rotate(-90deg);
  transform-origin: center;
  animation: ${circleFill} 2s ease;
`;

export default DounutChart;
